import React, { forwardRef } from 'react';
const Form = forwardRef(function Form({ testId = 'store-form', children, ...otherProps }, ref) {
    return (React.createElement("form", Object.assign({ ref: ref, "data-store-form": true, "data-testid": testId }, otherProps), children));
});
export default Form;
//# sourceMappingURL=Form.js.map